import {
  PriceComponentAPI,
  PriceComponentTypeModel,
  apiDeletePriceComponent,
  apiGetPriceComponent,
  apiGetPriceComponentDefaults,
  apiGetPriceComponentTypeById,
  apiGetPriceComponentTypes,
  apiGetPriceComponents,
  apiUpdatePriceComponentValue
} from '../../../api/Argentia/endpoints/priceComponents'
import { EnumPriceComponentReference } from '../../../api/Argentia/enums'
import { EnumPriceType } from '../../../api/oData/enums/enumPriceType'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../../model/serviceResponse'

export const getPriceComponents = async ({
  contractId,
  flexibilityId,
  leadId
}: {
  contractId?: number
  flexibilityId?: number
  leadId?: number
}): Promise<ServiceResponse<PriceComponentAPI[] | undefined>> => {
  return await apiGetPriceComponents({ contractId, flexibilityId, leadId })
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getPriceComponent = async ({
  id
}: {
  id?: number
}): Promise<ServiceResponse<PriceComponentAPI | undefined>> => {
  return await apiGetPriceComponent({ id })
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getPriceComponentDefaults = async (
  referenceType?: number,
  priceType?: number,
  commodity?: number,
  priceComponentTypeID?: number
): Promise<ServiceResponse<PriceComponentAPI[] | undefined>> => {
  return await apiGetPriceComponentDefaults(
    referenceType,
    priceType,
    commodity,
    priceComponentTypeID
  )
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getPriceComponentTypeById = async (
  priceComponentTypeID: number
): Promise<ServiceResponse<PriceComponentTypeModel | undefined>> => {
  return await apiGetPriceComponentTypeById(priceComponentTypeID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getPriceComponentTypes = async (
  referenceType?: EnumPriceComponentReference,
  priceType?: EnumPriceType,
  commodity?: number,
  expandDummy?: boolean
): Promise<ServiceResponse<PriceComponentTypeModel[] | undefined>> => {
  return await apiGetPriceComponentTypes(referenceType, priceType, commodity, expandDummy)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updatePriceComponentValue = async (
  id: number,
  newPriceValue: number | null
): Promise<ServiceResponse<null | undefined>> => {
  return await apiUpdatePriceComponentValue({ id, newPriceValue: newPriceValue ?? 0 })
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deletePriceComponent = async (
  id: number
): Promise<ServiceResponse<null | undefined>> => {
  return await apiDeletePriceComponent(id)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
